import { DuviCoreAdminAppShell } from "../../components/duvi-core-admin-app-shell";
import { useDuviCoreAdminNichesList } from "./use-duvi-core-admin-niches-list";
import { DuviCoreAdminNichesListView } from "./duvi-core-admin-niches-list-view";

export function DuviCoreAdminNichesList() {
  const state = useDuviCoreAdminNichesList();

  return (
    <DuviCoreAdminAppShell
      title="Niches"
      subtitle="Provisioned niche platforms from the Terragrunt registry"
      breadcrumbs={["Platform", "Niches"]}
      activeMenuItem="Niches"
    >
      <DuviCoreAdminNichesListView {...state} />
    </DuviCoreAdminAppShell>
  );
}
